module.exports = __webpack_public_path__ + "static/media/IconTemplates_-01.49e474d2.svg";